import { isNullOrEmpty } from "./string";
var GroupedMap = /** @class */ (function () {
    function GroupedMap() {
        this.mData = {};
    }
    GroupedMap.prototype.clear = function () {
        this.mData = {};
    };
    /**
     * Adds or overrides an data entry.
     * Data used as custom data has to be serializable as a JSON string.
     * If pData is undefined an existing entry will be removed.
     * The group key should be a unique identifer (e.g. an appliaction id or a module id)
     */
    GroupedMap.prototype.setData = function (pGroupKey, pDataKey, pData) {
        if (isNullOrEmpty(pGroupKey) || isNullOrEmpty(pDataKey))
            return;
        if (pData !== undefined) {
            var tGroup = this.getGroup(pGroupKey, true);
            tGroup[pDataKey] = pData;
        }
        else {
            //remove data entry
            var tGroup = this.getGroup(pGroupKey, false);
            if (tGroup != null && pDataKey in tGroup) {
                delete tGroup[pDataKey];
                //remove group
                if (!this.hasKeys(tGroup))
                    delete this.mData[pGroupKey];
            }
        }
    };
    /**
     * Get the value for an data entry.
     */
    GroupedMap.prototype.getData = function (pGroupKey, pDataKey) {
        if (isNullOrEmpty(pGroupKey) || isNullOrEmpty(pDataKey))
            return (undefined);
        var tGroup = this.getGroup(pGroupKey, false);
        if (tGroup != null) {
            var tData = tGroup[pDataKey];
            return (tData !== undefined ? tData : undefined);
        }
        return (undefined);
    };
    GroupedMap.prototype.serialize = function () {
        if (this.hasKeys(this.mData))
            return (this.mData);
        return (null);
    };
    GroupedMap.prototype.deserialize = function (pData) {
        this.mData = pData != null ? pData : {};
        return (true);
    };
    GroupedMap.prototype.getGroup = function (pGroupKey, pCreate) {
        var tGroup = this.mData[pGroupKey];
        if (tGroup != null)
            return tGroup;
        if (pCreate) {
            var tGroup_1 = {};
            this.mData[pGroupKey] = tGroup_1;
            return (tGroup_1);
        }
        return (undefined);
    };
    GroupedMap.prototype.hasKeys = function (pObj) {
        if (pObj == null)
            return (false);
        return (Object.keys(pObj).length !== 0);
    };
    return GroupedMap;
}());
export { GroupedMap };
export default GroupedMap;
